export default {
	state: {
		versionNumber:	'1.0.4',
	},
}